import React from "react";

import {
  pickPercent,
  getInstructorsDashboardPerformanceColors,
  getPerformanceValues
} from "components/analysis/utils";
import OnePanelChart from "components/analysis/OnePanelChart";
import Text from "components/analysis/Text";
import DivFormula from "components/analysis/DivFormula";

const MarketShare = ({ teams, metricsReports, currentGame, roundNumber }) => {
  const chartData = getPerformanceValues(
    pickPercent(teams, metricsReports, "market_share")
  );
  const colors = getInstructorsDashboardPerformanceColors(chartData.length);

  return (
    <OnePanelChart
      title="Market Share"
      suffix="%"
      data={chartData}
      customColors={colors}
      showCategoryLabels={true}
      instructorData={{ currentGame, roundNumber, type: "market-share" }}
    >
      <Text>
        Market Share represents the percentage of total sales that your business
        has captured within a market within a period of time. It is calculated
        by taking your business sales and dividing it by the total of all sales.
      </Text>
      <Text>
        For example, if Apple sold 36 smartphones in 2017 and there were a total
        of 100 smartphones sold in 2017, then Apple held 36% market share (i.e.
        36% = 36/100).
      </Text>
      <DivFormula
        name1="MARKET SHARE"
        name2="YOUR UNIT SALES"
        name3="TOTAL INDUSTRY SALES"
      />
    </OnePanelChart>
  );
};

export default MarketShare;



// WEBPACK FOOTER //
// ./src/instructor/components/dashboard/market-share.js